




































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Container from '@/components/Container.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import {
  EventValue,
  EventContact,
  JbicLocationDetails,
  EventStatus,
  CreateEventDTO,
  Event,
  UpdateEventDTO
} from '@/store/modules/admin/types/admin.types';
import { FormattedTimezone } from '@/store/modules/jtms/course/course.types';
import moment, { Moment } from 'moment-timezone';
import LocationAttributeRadioSelection from '@/views/JTMS/Dashboard/CreateCourses/CourseLevelAttributes/components/LocationAttributeRadioSelection.vue';
import {
  AddressCountry,
  AddressFilterOption,
  AddressState,
  GetSignedUrlForUploadResponsePayload,
  ImageFileSizeLimit,
  LocationType,
  VenueFieldData
} from '@/store/modules/admin/types/group-level-attribute.types';
import { Action, State } from 'vuex-class';
import { RootState } from '@/store/store';
import { ApiState } from '@/store/types/general.types';
import { clone } from '@/jbi-shared/util/group-level-attributes.util';
import FileUpload from '@/components/FileUpload.vue';
import { ToastProgrammatic } from 'buefy';
import draggable from 'vuedraggable';
import { GetSignedUrlForUploadRequestPayload } from '@/store/modules/static-file/types/static-file.types';
import dayjs from 'dayjs';
import DateTimeFieldComponent from '@/views/JTMS/Dashboard/CreateCourses/CourseModules/components/DateTimeFieldComponent.vue';

enum FieldKey {
  EventTitle = 'EventTitle',
  Slogan = 'Slogan',
  StartDate = 'StartDate',
  EndDate = 'EndDate',
  Timezone = 'Timezone',
  Description = 'Description',
  Location = 'Location',
  LineOne = 'LineOne',
  City = 'City',
  Postcode = 'Postcode',
  Country = 'Country',
  State = 'State',
  RemoteLink = 'RemoteLink',
  UrlToEvent = 'UrlToEvent',
  UrlToHost = 'UrlToHost',
  Contacts = 'Contacts',
  ContactName = 'ContactName',
  ContactRole = 'ContactRole',
  ContactPhone = 'ContactPhone',
  BannerImage = 'BannerImage',
  TeaserImage = 'TeaserImage'
}

@Component({
  components: {
    Container,
    ValidationObserver,
    ValidationProvider,
    LocationAttributeRadioSelection,
    FileUpload,
    draggable,
    DateTimeFieldComponent
  }
})
export default class CreateEvent extends Vue {
  @Action('admin/getCountries')
  getAllCountries!: (addressFilter?: AddressFilterOption) => void;

  @State(({ admin }: RootState) => admin.apiState.getCountries)
  getAllCountriesApiState!: ApiState;

  @State(({ admin }: RootState) => admin.countries)
  allCountries!: AddressCountry[] | undefined;

  @Action('admin/getCountryByCountryId')
  getCountryById!: (countryId?: number) => void;

  @State(({ admin }: RootState) => admin.apiState.getCountryById)
  getCountryByIdApiState!: ApiState;

  @State(({ admin }: RootState) => admin.countryById)
  countryById!: AddressCountry | undefined;

  @Action('staticFile/getSignedUrlForUploads')
  getSignedUrlForUploads!: (
    d: GetSignedUrlForUploadRequestPayload
  ) => Promise<GetSignedUrlForUploadResponsePayload>;

  @State(
    ({ staticFile }: RootState) => staticFile.apiState.getSignedUrlForUpload
  )
  getSignedUrlForUploadState!: ApiState;

  @State(({ staticFile }: RootState) => staticFile.signedUrlData)
  signedUrlData!: GetSignedUrlForUploadResponsePayload | undefined;

  @Action('admin/createEvent')
  createEvent!: (event: CreateEventDTO) => void;

  @State(({ admin }: RootState) => admin.apiState.createEvent)
  createEventApiState!: ApiState;

  @Action('admin/updateEvent')
  updateEvent!: (event: UpdateEventDTO) => void;

  @State(({ admin }: RootState) => admin.apiState.updateEvent)
  updateEventApiState!: ApiState;

  @Action('admin/getJbicEventById')
  getJbicEventById!: (eventId: number) => void;

  @State(({ admin }: RootState) => admin.apiState.getJbicEventById)
  getJbicEventByIdApiState!: ApiState;

  @State(({ admin }: RootState) => admin.jbicEvent)
  jbicEvent!: Event | undefined;

  // main params
  eventValues: EventValue = this.getInitFormParams();
  // store error messages
  errorMessages: Map<FieldKey, string> = new Map();

  // for location
  locationDetails: JbicLocationDetails = {
    locationType: LocationType.VENUE,
    venueDetails: {
      building: '',
      lineOne: '',
      lineTwo: '',
      city: '',
      postcode: '',
      country: '',
      state: ''
    },
    remoteLink: ''
  };
  currentStates: AddressState[] = [];

  // initialized for first entry
  contactDetails: EventContact[] = [
    {
      name: '',
      role: '',
      phoneNumber: ''
    }
  ];

  bannerImage: File = new File([], '');
  teaserImage: File = new File([], '');
  bannerImagePreviewUrl: string = '';
  teaserImagePreviewUrl: string = '';

  displayTimezone: string = this.formatTimezoneDisplay(moment.tz.guess());
  displayStartAt: Date = dayjs(new Date()).startOf('day').toDate();
  displayEndAt: Date | null = null;
  displayState: string = '';
  displayCountry: string = '';

  isLoading: boolean = false;
  saveClicked: boolean = false;
  currentStatus: EventStatus = EventStatus.DRAFT;

  formatTimezoneDisplay(timezone: string): string {
    const now: Moment = moment.tz(timezone); // Get current time in the timezone
    const offset = now.format('Z'); // Get UTC offset (e.g., +08:00)
    const parts = timezone.split('/');
    const simplifiedNameRaw = parts[parts.length - 1]; // Get the last segment
    const simplifiedName = simplifiedNameRaw.replace(/_/g, ' '); // Replace underscores with spaces
    return `${simplifiedName} (UTC ${offset})`;
  }

  formatTimezones(timezone: string): FormattedTimezone {
    const displayLabel = this.formatTimezoneDisplay(timezone);

    return {
      original: timezone,
      display: displayLabel
    };
  }

  get allFormattedTimezones(): FormattedTimezone[] {
    return (
      moment.tz
        .names()
        .map(this.formatTimezones)
        .sort((a, b) => {
          const offsetA = moment.tz(a.original).utcOffset();
          const offsetB = moment.tz(b.original).utcOffset();
          if (offsetA !== offsetB) return offsetA - offsetB;
          return a.display.localeCompare(b.display);
        }) ?? []
    );
  }

  get filteredTimezones(): FormattedTimezone[] {
    const searchTerm: string = this.displayTimezone.toLocaleLowerCase();

    return this.allFormattedTimezones.filter((tzObj) => {
      const matchesOriginal = tzObj.original
        .toLocaleLowerCase()
        .includes(searchTerm);
      const matchesDisplay = tzObj.display
        .toLocaleLowerCase()
        .includes(searchTerm);

      return matchesOriginal || matchesDisplay;
    });
  }

  findTimezoneOriginal(display: string): string {
    return (
      this.allFormattedTimezones.find(
        (timezone) =>
          timezone.display.toLocaleLowerCase() === display.toLocaleLowerCase()
      )?.original || ''
    );
  }

  findTimezoneDisplay(original: string): string {
    return (
      this.allFormattedTimezones.find(
        (timezone) =>
          timezone.original.toLocaleLowerCase() === original.toLocaleLowerCase()
      )?.display || ''
    );
  }

  get editorOption() {
    return {
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'link'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }]
        ]
      },
      placeholder: 'Ctrl/Cmd + Shift + V to paste without formatting'
    };
  }

  get countriesList(): AddressCountry[] {
    if (this.allCountries) {
      return this.allCountries.filter((country) => {
        return country.name
          .toLowerCase()
          .includes((this.displayCountry as string).toLowerCase());
      });
    }

    return [];
  }

  get statesList(): AddressState[] {
    if (this.currentStates.length > 0) {
      return this.currentStates.filter((state) => {
        return state.name
          .toLowerCase()
          .includes(
            (this.locationDetails.venueDetails?.state as string).toLowerCase()
          );
      });
    }

    return [];
  }

  get isStatesDisabled(): boolean {
    if (!this.locationDetails.venueDetails) {
      return false;
    }

    return this.displayCountry.length > 0 && this.currentStates.length === 0;
  }

  get groupId(): number {
    return +this.$route.params.groupId;
  }

  get changeType(): string {
    const changeType: string = this.$route.params.changeType;
    if (!['NEW', 'EDIT'].includes(changeType)) {
      return '';
    }
    return changeType;
  }

  get eventId(): number {
    return +this.$route.params.eventId;
  }

  mounted() {
    if (this.eventId > 0) {
      this.getJbicEventById(this.eventId);
    } else {
      this.eventValues = this.getInitFormParams();
    }
    this.resetErrorMessages();

    if (!this.allCountries) {
      this.getAllCountries();
    }
  }

  getInitFormParams(): EventValue {
    return {
      title: '',
      slogan: '',
      startAt: this.formatDate(new Date()),
      endAt: '',
      timezone: moment.tz.guess(),
      description: '',
      location: {
        locationType: LocationType.VENUE,
        venueDetails: {
          building: '',
          lineOne: '',
          lineTwo: '',
          city: '',
          postcode: '',
          country: '',
          state: ''
        },
        remoteLink: ''
      },
      urlToEvent: '',
      urlToHost: '',
      contacts: [
        {
          name: '',
          role: '',
          phoneNumber: ''
        }
      ],
      bannerImageUrl: '',
      teaserImageUrl: ''
    };
  }

  resetErrorMessages() {
    this.errorMessages.clear();
  }

  findErrorMessage(key: FieldKey) {
    return this.errorMessages.get(key);
  }

  formatDate(date: Date) {
    if (!date) {
      return '';
    }

    return dayjs(date).format('DD MMM YYYY');
  }

  handleTimezoneSelect(selection: FormattedTimezone): void {
    if (selection) {
      this.eventValues.timezone = selection.original;
      return;
    }

    // Assign empty TZ
    this.eventValues.timezone = '';
  }

  updateLocationConfig(locationType: LocationType) {
    this.locationDetails.locationType = locationType;
  }

  removeContact(valueIndex: number) {
    this.contactDetails.splice(valueIndex, 1);
  }

  addContact() {
    this.contactDetails.push({
      name: '',
      role: '',
      phoneNumber: ''
    });
  }

  async handleBackRedirect() {
    this.$router.go(-1);
  }

  processFile(selectedFile: File, whichImage: FieldKey) {
    if (![FieldKey.BannerImage, FieldKey.TeaserImage].includes(whichImage)) {
      return;
    }

    if (!selectedFile) {
      return;
    }

    if (selectedFile.size > ImageFileSizeLimit) {
      ToastProgrammatic.open({
        message: `File '${selectedFile.name}' has exceeded size limitation.`,
        type: 'is-danger',
        position: 'is-top'
      });
      return;
    }

    const fileName: string = `jbic_${whichImage.toLocaleLowerCase()}_${new Date().getTime()}.${selectedFile.name
      .split('.')
      .pop()}`;

    if (whichImage === FieldKey.BannerImage) {
      this.bannerImage = selectedFile;
      this.bannerImagePreviewUrl = URL.createObjectURL(selectedFile);
    } else if (whichImage === FieldKey.TeaserImage) {
      this.teaserImage = selectedFile;
      this.teaserImagePreviewUrl = URL.createObjectURL(selectedFile);
    }

    // method to synchronously get signed url for selected file
    return this.getSignedUrlForUploads({
      fileName: fileName,
      contentType: selectedFile.type,
      groupId: this.groupId,
      entityType: 'event',
      bucket: 'jbic'
    });
  }

  removeUploadedContent(whichImage: FieldKey) {
    if (whichImage === FieldKey.BannerImage) {
      this.eventValues.bannerImageUrl = '';
      this.bannerImage = new File([], '');
      URL.revokeObjectURL(this.bannerImagePreviewUrl);
      this.bannerImagePreviewUrl = '';
    } else if (whichImage === FieldKey.TeaserImage) {
      this.eventValues.teaserImageUrl = '';
      this.teaserImage = new File([], '');
      URL.revokeObjectURL(this.teaserImagePreviewUrl);
      this.teaserImagePreviewUrl = '';
    } else {
      return;
    }
  }

  createEventHandler(status: EventStatus) {
    this.isLoading = true;
    this.saveClicked = true;

    this.verifyEventValues();

    // DRAFT can save without complete
    if (status !== EventStatus.DRAFT && this.errorMessages.size > 0) {
      this.isLoading = false;
      return;
    }

    const payload: CreateEventDTO = {
      isDraft: status === EventStatus.DRAFT,
      groupId: this.groupId,
      status: status,
      title: this.eventValues.title,
      slogan: this.eventValues.slogan,
      startAt: dayjs(this.eventValues.startAt).format('YYYY-MM-DD HH:mm:ss'),
      endAt: this.eventValues.endAt
        ? dayjs(this.eventValues.endAt).format('YYYY-MM-DD HH:mm:ss')
        : '',
      timezone: this.eventValues.timezone,
      description: this.eventValues.description,
      location: this.eventValues.location,
      contacts: this.eventValues.contacts,
      urlToEvent: this.eventValues.urlToEvent,
      urlToHost: this.eventValues.urlToHost,
      bannerImageUrl: this.eventValues.bannerImageUrl,
      teaserImageUrl: this.eventValues.teaserImageUrl
    };

    if (this.changeType === 'NEW') {
      this.createEvent(payload);
    } else if (this.changeType === 'EDIT') {
      const params: UpdateEventDTO = { id: this.eventId, payload };
      this.updateEvent(params);
    }
  }

  verifyEventValues() {
    if (!this.saveClicked) {
      return;
    }

    if (!this.eventValues.title || this.eventValues.title.length === 0) {
      this.errorMessages.set(FieldKey.EventTitle, 'Title is mandatory');
    } else {
      this.errorMessages.delete(FieldKey.EventTitle);
    }

    if (!this.eventValues.slogan || this.eventValues.slogan.length === 0) {
      this.errorMessages.set(FieldKey.Slogan, 'Slogan is mandatory');
    } else {
      this.errorMessages.delete(FieldKey.Slogan);
    }

    if (!this.eventValues.startAt) {
      this.errorMessages.set(FieldKey.StartDate, 'Start Date is mandatory');
    } else {
      this.errorMessages.delete(FieldKey.StartDate);
    }

    if (!this.eventValues.endAt) {
      this.errorMessages.set(FieldKey.EndDate, 'End Date is mandatory');
    } else {
      this.errorMessages.delete(FieldKey.EndDate);
    }

    if (!this.eventValues.timezone || this.eventValues.timezone.length === 0) {
      this.errorMessages.set(FieldKey.Timezone, 'Timezone is mandatory');
    } else {
      this.errorMessages.delete(FieldKey.Timezone);
    }

    if (
      !this.eventValues.description ||
      this.eventValues.description.length === 0
    ) {
      this.errorMessages.set(FieldKey.Description, 'Description is mandatory');
    } else {
      this.errorMessages.delete(FieldKey.Description);
    }

    const location: JbicLocationDetails = this.eventValues.location;
    let hasLocationError: boolean = false;

    if (!location) {
      hasLocationError = true;
    }

    if (
      !hasLocationError &&
      [LocationType.BOTH, LocationType.VENUE].includes(location.locationType)
    ) {
      const venue: VenueFieldData | undefined = location.venueDetails;
      const venueFieldsMissing =
        !venue ||
        !venue.lineOne ||
        !venue.city ||
        !venue.postcode ||
        !venue.country ||
        (this.statesList.length > 0 && !venue.state);
      if (venueFieldsMissing) {
        hasLocationError = true;
      }
    }

    if (
      !hasLocationError &&
      [LocationType.BOTH, LocationType.REMOTE].includes(location.locationType)
    ) {
      hasLocationError = !location.remoteLink;
    }

    if (hasLocationError) {
      this.errorMessages.set(FieldKey.Location, 'Location is mandatory');
    } else {
      this.errorMessages.delete(FieldKey.Location);
    }

    if (
      !this.eventValues.urlToEvent ||
      this.eventValues.urlToEvent.length === 0
    ) {
      this.errorMessages.set(FieldKey.UrlToEvent, 'Event URL is mandatory');
    } else {
      this.errorMessages.delete(FieldKey.UrlToEvent);
    }

    if (
      !this.eventValues.urlToHost ||
      this.eventValues.urlToHost.length === 0
    ) {
      this.errorMessages.set(FieldKey.UrlToHost, 'Host URL is mandatory');
    } else {
      this.errorMessages.delete(FieldKey.UrlToHost);
    }

    const contacts = this.eventValues.contacts;
    const firstContact = contacts && contacts.length > 0 ? contacts[0] : null;
    const isContactInvalid =
      !contacts ||
      (firstContact &&
        (!firstContact.name ||
          !firstContact.phoneNumber ||
          !firstContact.role));
    if (isContactInvalid) {
      this.errorMessages.set(
        FieldKey.Contacts,
        'Contacts is mandatory (at least one)'
      );
    } else {
      this.errorMessages.delete(FieldKey.Contacts);
    }

    if (
      !this.eventValues.bannerImageUrl ||
      this.eventValues.bannerImageUrl.length === 0
    ) {
      this.errorMessages.set(FieldKey.BannerImage, 'Banner Image is mandatory');
    } else {
      this.errorMessages.delete(FieldKey.BannerImage);
    }

    if (
      !this.eventValues.teaserImageUrl ||
      this.eventValues.teaserImageUrl.length === 0
    ) {
      this.errorMessages.set(FieldKey.TeaserImage, 'Teaser Image is mandatory');
    } else {
      this.errorMessages.delete(FieldKey.TeaserImage);
    }
  }

  showUploadToastError(message?: string) {
    ToastProgrammatic.open({
      message: message || 'Upload failed. Please try again.',
      type: 'is-danger',
      position: 'is-top'
    });
  }

  async uploadFileToSignedUrl(
    selectedFile: File,
    payload: GetSignedUrlForUploadResponsePayload
  ): Promise<GetSignedUrlForUploadResponsePayload> {
    const formData = new FormData();
    formData.append('file', selectedFile as Blob);

    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', payload.signedUrl, true);
      xhr.setRequestHeader('Content-Type', selectedFile.type);

      xhr.onload = (e) => {
        if (xhr.status < 200 || xhr.status >= 300) {
          return reject(new Error(`Upload failed with status ${xhr.status}`));
        }
        if (
          payload.fileName.includes(FieldKey.BannerImage.toLocaleLowerCase())
        ) {
          this.eventValues.bannerImageUrl = payload.storageUrl;
          this.verifyEventValues();
        } else if (
          payload.fileName.includes(FieldKey.TeaserImage.toLocaleLowerCase())
        ) {
          this.eventValues.teaserImageUrl = payload.storageUrl;
          this.verifyEventValues();
        }
        return resolve(payload);
      };

      xhr.onerror = (error) => {
        return reject(error);
      };

      xhr.send(selectedFile);
    });
  }

  @Watch('getCountryByIdApiState')
  validateStateCallback(): void {
    if (
      this.getCountryByIdApiState.error ||
      this.getCountryByIdApiState.loading ||
      !this.getCountryByIdApiState.success ||
      !this.countryById
    ) {
      return;
    }

    this.currentStates = clone(this.countryById.states) as AddressState[];
  }

  @Watch('eventValues', { deep: true })
  onEventValues() {
    this.verifyEventValues();
  }

  @Watch('locationDetails', { deep: true })
  onLocationDetails() {
    this.eventValues.location = this.locationDetails;
    this.displayState = this.locationDetails.venueDetails
      ? this.locationDetails.venueDetails.state
      : '';
    this.displayCountry = this.locationDetails.venueDetails
      ? this.locationDetails.venueDetails.country
      : '';
  }

  @Watch('contactDetails', { deep: true })
  onContactDetails() {
    this.eventValues.contacts = this.contactDetails;
  }

  @Watch('createEventApiState')
  onCreateEventApiState() {
    this.isLoading = true;

    if (this.createEventApiState.loading || !this.createEventApiState.success) {
      return;
    }

    this.isLoading = false;

    if (this.createEventApiState.error) {
      ToastProgrammatic.open({
        queue: true,
        type: 'is-danger',
        position: 'is-top',
        message: `Failed to create event ${this.eventValues.title}. Please try again later.`,
        duration: 5000
      });
    }

    if (this.createEventApiState.success) {
      ToastProgrammatic.open({
        queue: true,
        type: 'is-success',
        position: 'is-top',
        message: `Event ${this.eventValues.title} successfully created.`,
        duration: 5000
      });
      this.handleBackRedirect();
    }
  }

  @Watch('updateEventApiState')
  onUpdateEventApiState() {
    this.isLoading = true;

    if (this.updateEventApiState.loading || !this.updateEventApiState.success) {
      return;
    }

    this.isLoading = false;

    if (this.updateEventApiState.error) {
      ToastProgrammatic.open({
        queue: true,
        type: 'is-danger',
        position: 'is-top',
        message: `Failed to update event ${this.eventValues.title}. Please try again later.`,
        duration: 5000
      });
    }

    if (this.updateEventApiState.success) {
      ToastProgrammatic.open({
        queue: true,
        type: 'is-success',
        position: 'is-top',
        message: `Event ${this.eventValues.title} successfully updated.`,
        duration: 5000
      });
      this.handleBackRedirect();
    }
  }

  @Watch('getSignedUrlForUploadState', { deep: true })
  onStateChange(state: ApiState) {
    if (state.error) {
      // reset on error
      this.showUploadToastError();
    }

    if (!this.signedUrlData || !state.success) {
      return;
    }

    let fileToUpload: File = new File([], '');
    if (
      this.signedUrlData.fileName.includes(
        FieldKey.BannerImage.toLocaleLowerCase()
      )
    ) {
      fileToUpload = this.bannerImage;
    } else if (
      this.signedUrlData.fileName.includes(
        FieldKey.TeaserImage.toLocaleLowerCase()
      )
    ) {
      fileToUpload = this.teaserImage;
    }

    this.uploadFileToSignedUrl(fileToUpload, this.signedUrlData).catch(() => {
      this.showUploadToastError();
    });
  }

  @Watch('getJbicEventByIdApiState')
  onGetJbicEventByIdApiState() {
    if (
      this.getJbicEventByIdApiState.loading ||
      this.getJbicEventByIdApiState.error ||
      !this.jbicEvent
    ) {
      return;
    }

    this.eventValues = {
      title: this.jbicEvent.title,
      slogan: this.jbicEvent.slogan,
      startAt: dayjs(this.jbicEvent.startAt).format('YYYY-MM-DD HH:mm:ss'),
      endAt: dayjs(this.jbicEvent.startAt).format('YYYY-MM-DD HH:mm:ss'),
      timezone: this.jbicEvent.timezone,
      description: this.jbicEvent.description,
      location: this.jbicEvent.location,
      urlToEvent: this.jbicEvent.urlToEvent,
      urlToHost: this.jbicEvent.urlToHost,
      contacts: this.jbicEvent.contacts,
      bannerImageUrl: this.jbicEvent.bannerImageUrl,
      teaserImageUrl: this.jbicEvent.teaserImageUrl
    };

    this.bannerImagePreviewUrl = this.jbicEvent.bannerImageUrl || '';
    this.teaserImagePreviewUrl = this.jbicEvent.teaserImageUrl || '';

    this.locationDetails = this.jbicEvent.location;
    this.contactDetails = this.jbicEvent.contacts;
    this.displayTimezone = this.findTimezoneDisplay(this.jbicEvent.timezone);
    this.displayStartAt = new Date(this.jbicEvent.startAt);
    this.displayEndAt = new Date(this.jbicEvent.endAt);
    this.currentStatus = this.jbicEvent.status;
  }

  @Watch('displayTimezone')
  onDisplayTimezone() {
    this.eventValues.timezone = this.findTimezoneOriginal(this.displayTimezone);
  }

  @Watch('displayStartAt')
  onDisplayStartAt() {
    this.eventValues.startAt = dayjs(this.displayStartAt).format(
      'YYYY-MM-DD HH:mm:ss'
    );
  }

  @Watch('displayEndAt')
  onDisplayEndAt() {
    this.eventValues.endAt = this.displayEndAt
      ? dayjs(this.displayEndAt).format('YYYY-MM-DD HH:mm:ss')
      : '';
  }

  @Watch('displayState')
  onDisplayState() {
    const venueDetails: VenueFieldData | undefined = this.locationDetails
      .venueDetails;

    if (!venueDetails) {
      return;
    }
    venueDetails.state = this.displayState;

    this.locationDetails.venueDetails = venueDetails;
  }

  @Watch('displayCountry')
  onDisplayCountry() {
    if (this.displayCountry) {
      const currentCountryName: string = this.displayCountry;
      if (currentCountryName.length === 0) {
        this.displayState = '';
        this.currentStates = [];
        return;
      }

      const targetCountry = this.allCountries?.find(
        (country) =>
          country.name.toLowerCase() === currentCountryName.toLowerCase()
      );
      if (!targetCountry) {
        this.displayState = '';
        this.currentStates = [];
        return;
      }

      this.getCountryById(targetCountry?.id);
    }

    const venueDetails: VenueFieldData | undefined = this.locationDetails
      .venueDetails;

    if (!venueDetails) {
      return;
    }
    venueDetails.country = this.displayCountry;

    this.locationDetails.venueDetails = venueDetails;
  }
}
